import { DivRow } from "./style";


const Row = ({w=100, 
    children,
    justifyContent='start',
    alignItems='center',
    margin='auto',
    padding=0

}) => {
    return ( 
        <DivRow 
        w={w} 
        justifyContent={justifyContent}
        alignItems={alignItems}
        margin={margin}
        padding={padding}

        >
            {children}
            </DivRow>
     );
}
 
export default Row;